import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const createOneServerDriverObj = (dispatch, navigate) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.createOneServerName',
        popover: {
          title: 'Server Name',
          description: 'Enter a unique name for your server. This will help you identify it later.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.createOneServerServer',
        popover: {
          title: 'Server Address',
          description:
            'Provide the address of the server you are connecting to. This could be an IP address or a domain name.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.createOneServerEmail',
        popover: {
          title: 'Email Address',
          description: 'Enter your email address for notifications and account recovery purposes.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.createOneServerUser',
        popover: {
          title: 'Username',
          description:
            'Specify the username that will be used to access the server. Make sure it is secure and not easily guessable.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.createOneServerPassword',
        popover: {
          title: 'Password',
          description:
            'Create a strong password for your server account. Use a mix of letters, numbers, and special characters.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default createOneServerDriverObj;
